import axios from "axios";
import { route } from "ziggy";

export const downloadProducts = async (
    includeBundles,
    ignoreDeleted,
    onlyRecurring = false,
    quoteProfileId = null,
    easyDownload = false,
    searchQuery = "",
) => {
    if (easyDownload) {
        const url = route("products.searchWithBundles", {
            includeBundles,
            quote_profile_id: quoteProfileId,
            recurring: onlyRecurring,
            deleted: ignoreDeleted,
            query: searchQuery,
        });
        const response = await axios.get(url);

        return response.data;
    }

    const bundles = [];
    if (includeBundles && !onlyRecurring) {
        let bundlesNextUrl = route("products.bundles.index");
        while (bundlesNextUrl) {
            const bundlesResponse = await axios.get(bundlesNextUrl);
            bundles.push(...bundlesResponse.data.data);
            bundlesNextUrl = bundlesResponse.data.links.next;

            if (location.hostname === "localhost") {
                break;
            }
        }

        bundles.forEach((bundle) => {
            bundle.id = `bundle-${bundle.id}`;
            bundle.type = "bundle";
        });
        bundles.sort((left, right) => left.name.toLowerCase().localeCompare(right.name.toLowerCase()));
    }

    const products = [];
    let productsNextUrl = route("products.index", {
        quote_profile_id: quoteProfileId,
        recurring: onlyRecurring,
        deleted: ignoreDeleted,
    });

    while (productsNextUrl) {
        const productsResponse = await axios.get(productsNextUrl);
        products.push(...productsResponse.data.data);
        if (!productsResponse.data.links.next) {
            break;
        }

        productsNextUrl = `${productsResponse.data.links.next}${quoteProfileId ? `&quote_profile_id=${quoteProfileId}` : ""}&recurring=${onlyRecurring}&deleted=${ignoreDeleted}`;
    }

    products.forEach((product) => {
        product.type = "product";
    });
    products.sort((left, right) => left.name.toLowerCase().localeCompare(right.name.toLowerCase()));

    return bundles.concat(products);
};
